import Hero from "../../shared/landing/hero/Hero"
import Info from "../../shared/landing/info/Info"
import Promotions from "../../shared/landing/promotions/Promotions"
import SinglePromotion from "../../shared/landing/promotions/SinglePromotion"
import PromotionsCalendar from "../../shared/landing/BlackFridayCalendar/BlackFridayCalendar"
import PastPromotions from "../../shared/landing/past-promotions/PastPromotions"
import Team from "../../shared/landing/team/Team"
import Testimonial from "../../shared/landing/testimonial/Testimonial"
import Faq from "../../shared/landing/faq/Faq"
import { useEffect, useState } from "react"
import { productDetailService } from "../../../services/productDetailService"
import { ProductDetailData } from "../../../models/ProductDetailData"
import { blackFridayFaqsData } from "./data/blackFridayFaqsData"

import landscapeVideoUrl from "../../../assets/blackfriday/vikika-team-landscape.mp4"
import portraitVideoUrl from "../../../assets/blackfriday/vikika-team-portrait.mp4"
import { getSalePeriod, SalePeriod } from "./utils/getSalePeriod"
import isBlackFriday from "./utils/isBlackFriday"

const BlackFriday = () => {
  const [dietProducts, setDietProducts] = useState<ProductDetailData[]>([])
  const [psychologyProducts, setPsychologyProducts] = useState<ProductDetailData[]>([])
  const [salePeriod, setSalePeriod] = useState<SalePeriod>(getSalePeriod())
  const [showPromotions] = useState<boolean>(isBlackFriday(new Date()))

  const today = new Date()

  const todayKey = today
    .toLocaleDateString("es-ES", { weekday: "long", day: "2-digit" })
    .replace(",", "")
    .toLowerCase()

  const getDayNumber = (dateStr: string) => parseInt(dateStr.split(" ")[1], 10)
  const todayNumber = getDayNumber(todayKey)

  useEffect(() => {
    const fetchData = async () => {
      const dietProducts = await productDetailService("diet")
      const psychologyProducts = await productDetailService("psychology")
      setDietProducts(dietProducts)
      setPsychologyProducts(psychologyProducts)
    }
    fetchData()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setSalePeriod(getSalePeriod())
    }, 1000 * 60 * 60) // cada hora basta
    return () => clearInterval(interval)
  }, [])

  const scrollToPromotions = () => {
    const promotionsElement = document.getElementById("promotions")
    if (promotionsElement) {
      promotionsElement.scrollIntoView({ behavior: "smooth" })
    }
  }

  const heroTexts = {
    [SalePeriod.BLACK_FRIDAY]: {
      marquee: "SEMANA BLACK FRIDAY ¡CADA DÍA UN DESCUENTO ÚNICO!",
      title: "OFERTAS<br/>BLACK FRIDAY",
      subtitle: "VIKIKA TEAM"
    },
    [SalePeriod.CYBER_MONDAY]: {
      marquee: "ÚLTIMO DÍA OFERTA CYBER MONDAY",
      title: "¡CYBER MONDAY!",
      subtitle: "VIKIKA TEAM"
    },
    [SalePeriod.BEFORE]: {
      marquee: "PRÓXIMAMENTE... SEMANA BLACK FRIDAY",
      title: "OFERTAS<br/>BLACK FRIDAY",
      subtitle: "VIKIKA TEAM"
    },
    [SalePeriod.AFTER]: {
      marquee: "BLACK FRIDAY FINALIZADO",
      title: "¡GRACIAS POR PARTICIPAR!",
      subtitle: "VIKIKA TEAM"
    }
  }[salePeriod]

  const singleProducts = [
    {
      id: "bf-nutrition-1",
      date: "lunes 24",
      discount: 20,
      title: "Plan Dieta + entrenamiento<br />individual",
      subtitle:
        "Elige el plan que más se adapte a ti. Puedes escoger entre entrenamiento en casa, gym o con entrena virtual.",
      type: "nutrition",
      hasOptions: true,
      inCouple: false
    },
    {
      id: "bf-psychology-1",
      date: "martes 25",
      discount: 15,
      title: "Sesiones Psicología<br />individual",
      subtitle: "Salud física y mental van de la mano con nuestras sesiones de psicología online.",
      type: "psychology",
      showSessionOptions: true,
      inCouple: false
    },
    {
      id: "bf-nutrition-2",
      date: "miércoles 26",
      discount: 20,
      title: "Plan Dieta<br />pareja",
      subtitle:
        "Si compartís un mismo objetivo, este plan en pareja os facilitará vuestro día a día, respetando vuestras necesidades individuales.",
      type: "nutrition",
      hasOptions: false,
      inCouple: true
    },
    {
      id: "bf-nutrition-3",
      date: "jueves 27",
      discount: 20,
      title: "Plan Dieta + entrenamiento<br />pareja",
      subtitle:
        "Si compartís un mismo objetivo, este es vuestro plan. Elegid el plan que más se adapte a vosotros escogiendo el tipo de entrenamiento en casa o gym.",
      type: "nutrition",
      hasOptions: true,
      inCouple: true
    },
    {
      date: "viernes 28",
      discount: 20,
      title: "Plan Dieta<br />individual",
      subtitle:
        "Si quieres lograr un cambio en tus hábitos y en tu estilo de vida a través de la nutrición, este es tu plan. Incluye Planes Embarazo y Menopausia.",
      type: "nutrition",
      hasOptions: false,
      inCouple: false,
      cardTitle: "¡Descuentos sorpresa!",
      showDiscountPreview: false
    },
    {
      id: "bf-psychology-2",
      date: "sábado 29",
      discount: 15,
      title: "Sesiones Psicología<br />pareja",
      subtitle: "Salud física y mental van de la mano con nuestras sesiones de psicología online.",
      type: "psychology",
      showSessionOptions: true,
      inCouple: true
    },
    {
      id: "bf-psychology-3",
      date: "domingo 30",
      discount: 15,
      title: "Suscripción Psicología<br />individual",
      subtitle: "Salud física y mental van de la mano con nuestras sesiones de psicología online.",
      type: "psychology",
      showSubscriptionOptions: true,
      inCouple: false
    }
  ]

  const product = singleProducts.find(card => card.date === todayKey) || singleProducts[5]

  const prominentProduct = singleProducts.find(card => card.date === "viernes 28")

  const cards = singleProducts
    .filter(card => card.date !== todayKey)
    .map(card => {
      const cardDay = getDayNumber(card.date)
      return {
        ...card,
        ...(cardDay < todayNumber ? { isPast: true } : {})
      }
    })

  const pastPromotions = cards.filter(card => card.isPast === true && card.date !== "viernes 28")

  return (
    <div className="bf-landing">
      <Hero
        scrollToPromotions={showPromotions ? scrollToPromotions : undefined}
        marqueeText={heroTexts.marquee}
        title={heroTexts.title}
        subtitle={heroTexts.subtitle}
        videoLandscapeUrl={landscapeVideoUrl}
        videoPortraitUrl={portraitVideoUrl}
      />
      {showPromotions ? (
        <>
          {todayKey === "viernes 28" || salePeriod === SalePeriod.CYBER_MONDAY ? (
            <Info
              title={
                salePeriod === SalePeriod.CYBER_MONDAY
                  ? "¡Último día de ofertas con Cyber Monday!"
                  : "¡Todos los días tenemos un descuento nuevo para ti!"
              }
              subtitle={
                salePeriod === SalePeriod.CYBER_MONDAY
                  ? "Aprovecha el último día de ofertas de Vikika Team con descuentos en todos nuestros productos."
                  : undefined
              }
            />
          ) : null}
          <div id="promotions">
            {salePeriod !== SalePeriod.CYBER_MONDAY &&
            todayKey !== "viernes 28" &&
            prominentProduct ? (
              <SinglePromotion
                dietProducts={dietProducts}
                psychologyProducts={psychologyProducts}
                inCouple={prominentProduct.inCouple}
                subtitle={prominentProduct.subtitle}
                title={prominentProduct.title}
                type={prominentProduct.type}
                hasOptions={prominentProduct.hasOptions}
                showSessionOptions={prominentProduct.showSessionOptions}
                showSubscriptionOptions={prominentProduct.showSubscriptionOptions}
                discount={prominentProduct.discount}
                prominentPromotion={true}
                hasBackground={false}
              />
            ) : null}
            {salePeriod === SalePeriod.CYBER_MONDAY || todayKey === "viernes 28" ? (
              <Promotions
                dietProducts={dietProducts}
                psychologyProducts={psychologyProducts}
                nutriDiscount={salePeriod === SalePeriod.CYBER_MONDAY ? 15 : 20}
                psychoDiscount={salePeriod === SalePeriod.CYBER_MONDAY ? 10 : 15}
              />
            ) : (
              <SinglePromotion
                dietProducts={dietProducts}
                psychologyProducts={psychologyProducts}
                inCouple={product.inCouple}
                subtitle={product.subtitle}
                title={product.title}
                type={product.type}
                hasOptions={product.hasOptions}
                showSessionOptions={product.showSessionOptions}
                showSubscriptionOptions={product.showSubscriptionOptions}
                discount={product.discount}
              />
            )}
          </div>
          {salePeriod !== SalePeriod.CYBER_MONDAY ? (
            <PromotionsCalendar cards={cards} disableLinks={todayKey === "viernes 28"} />
          ) : null}
        </>
      ) : null}
      {salePeriod !== SalePeriod.CYBER_MONDAY && todayKey !== "viernes 28" ? (
        <PastPromotions
          pastPromotions={pastPromotions}
          dietProducts={dietProducts}
          psychologyProducts={psychologyProducts}
        />
      ) : null}
      <Team />
      <Faq dataToDisplay={blackFridayFaqsData} />
      <Testimonial />
    </div>
  )
}

export default BlackFriday
